//import services from "@/http";
import * as types from "./mutation-types";

export const ActionSetMessage = ({ commit }, payload) => {
  commit(types.SET_MESSAGE, payload);
};
